// @flow
import React from "react";
import Permit from "../../../svg/facilities/has_permit.svg";
import "./permitIcon.scss";

const PermitIcon = () => <Permit className="c-permit-icon" />;

export default PermitIcon;
